import * as React from "react";
import { StyleSheet, View, Text, TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { currentLanguage } from "../../translations/CurrentLanguage";

import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors, radius } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

const IdleComponent = props => {
  strings.setLanguage(currentLanguage().companyLanguage);
  return (
    <View style={styles.view}>
      <View style={styles.icon}>
        <Icon name="plus" size={24} color={colors.primary} />
      </View>
      <Text style={styles.text}>
        {strings.WouldYouLikeToCreateNew} {props.type}?
      </Text>
      <TouchableOpacity
        activeOpacity={0.85}
        style={styles.button}
        onPress={props.onPress}
      >
        <Text style={styles.buttonText}>
          {strings.CreateNew} {props.type}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  view: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  icon: {
    width: 64,
    height: 64,
    marginBottom: 16,
    borderRadius: 32,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.primarySoft,
  },
  text: {
    marginBottom: 16,
    fontSize: 16,
    fontWeight: "600",
    textAlign: "center",
    color: colors.text,
  },
  button: {
    height: 46,
    paddingHorizontal: 22,
    borderRadius: radius.medium,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.primary,
  },
  buttonText: {
    fontSize: 15,
    fontWeight: "700",
    color: "#fff",
  },
});

export default IdleComponent;
